/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Slash = [["path", { d: "M22 2 2 22" }]];

export { Slash as default };
//# sourceMappingURL=slash.js.map
